import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
function ExploreCollectionCard({ data }) {
  console.log(data);
  return (
    <div className="property__list__wrapper">
      <div className="row d-flex align-items-center">
        <div className="col-lg-5">
          <div className="property__item__image column__space--secondary">
            <div className="img__effect">
              <Link to="/all-collections">
                <img src={imageUrl(data.img)} alt="Mezzo" />
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="property__item__content ">
            <div className="item__head">
              <div className="item__head__left">
                <h4>{data.city}</h4>
                <p>
                  <i className="fa-solid fa-location-dot"></i> {data.location}
                </p>
              </div>
              <div className="item__head__right">
                <div className="countdown__wrapper">
                  <p className="secondary">Units Left to invest</p>
                  <div className="countdown justify-content-center">
                    <h5>
                      <span className="days">{data.unitsLeft}</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="progress__type progress__type--two">
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <div className="project__info">
                <p className="project__has">
                  <span className="project__has__investors">119 Investors</span>{" "}
                  |{" "}
                  <span className="project__has__investors__amount">
                    RM 4,94,196
                  </span>{" "}
                  <span className="project__has__investors__percent">
                    (54.73%)
                  </span>
                </p>
                <p className="project__goal">RM 1,00,000 Goal</p>
              </div>
            </div>
            <div className="item__info justify-content-around">
              <div className="item__info__single">
                <p>Completion Year</p>
                <h6>{data.completionYear}</h6>
              </div>
              <div className="item__info__single">
                <p>Property Type</p>
                <h6>{data.type}</h6>
              </div>
              <div className="item__info__single">
                <p>Total Units</p>
                <h6>{data.totalUnits}</h6>
              </div>
            </div>
            <div className="item__footer">
              <div className="item__security">
                <div className="icon__box">
                  <img src={imageUrl("icons/home.png")} alt="Security" />
                </div>
                <div className="item__security__content">
                  <p className="secondary">Security</p>
                  <h6>1st-Rank Mortgage</h6>
                </div>
              </div>
              <div className="item__cta__group">
                <Link to="/all-collections" className="button button--effect">
                  Book Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExploreCollectionCard;
